import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const leaderboardSwitch = definePartsStyle({
  track: {
    background:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 100%);',
    borderColor: 'white.10',
    borderWidth: '1.5px',
    borderRadius: '8px',
    backgroundOrigin: 'border-box',
    p: 0.5,
    _checked: {
      background:
        'linear-gradient(180deg, rgba(38, 166, 154, 0) 0%, rgba(38, 166, 154, 0.4) 100%);',
      _hover: {
        background:
          'linear-gradient(180deg, rgba(38, 166, 154, 0) 0%, rgba(38, 166, 154, 0.6) 100%);',
      },
    },
    _hover: {
      background:
        'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 100%);',
      backgroundOrigin: 'border-box',
    },
  },
  thumb: {
    background:
      'linear-gradient(360deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);',
    borderColor: 'white.10',
    backgroundOrigin: 'border-box',
    borderRadius: '8px',
    borderWidth: '0.5px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    justifyContent: 'center',
    position: 'relative',
    _before: {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      background: 'black',
      maskImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.66 10L9.16 12.5L13.34 8.34' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
      maskPosition: 'center',
      maskRepeat: 'no-repeat',
      opacity: 1,
      transition: 'background 0.2s',
    },
    _checked: {
      '&::before': {
        background: 'treasuredTeal.100',
      },
      background:
        'linear-gradient(360deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);',
      backgroundOrigin: 'border-box',
      _hover: {
        background:
          'linear-gradient(360deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(0deg, #131313, #131313)',
        backgroundOrigin: 'border-box',
      },
    },
    _hover: {
      background:
        'linear-gradient(360deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(0deg, #131313, #131313)',
      backgroundOrigin: 'border-box',
    },
  },
});

export const switchTheme = defineMultiStyleConfig({
  baseStyle: {
    track: {
      bg: 'transparent',
      borderColor: 'white.60',
      borderWidth: '0.188rem',
      _checked: {
        borderColor: 'treasuredTeal.100',
      },
    },
    thumb: {
      bg: 'transparent',
      boxShadow: 'inset 0 0 0 0.188rem rgba(255, 255, 255, 0.6)',
      _checked: {
        boxShadow: 'inset 0 0 0 0 rgba(255, 255, 255, 0)',
        bg: 'treasuredTeal.100',
      },
    },
  },
  variants: {
    leaderboard: leaderboardSwitch,
  },
});
